import { combineReducers } from "redux"

import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"

import tagging from "./tagging"
import followUp from "./followUp"

const unflaggedQuestion = setterReducer(null, t.SET_UNFLAGGED_QUESTION)
const flag = setterReducer(null, t.SET_FLAG)
const flagFeedback = setterReducer(null, t.SET_FLAG_FEEDBACK)
const explanation = setterReducer(null, t.SET_EXPLANATION)
const showNpsCard = setterReducer(false, t.SET_SHOW_NPS_CARD)
const npsScore = setterReducer(null, t.SUBMIT_NPS_SCORE)
const npsComment = setterReducer(null, t.SUBMIT_NPS_COMMENT)
const npsSubmitted = setterReducer(false, t.SET_NPS_SUBMITTED)
const getNpsFeedback = setterReducer(false, t.SET_GET_NPS_FEEDBACK)
const showPostIntentPopUp = setterReducer(false, t.SET_SHOW_POST_INTENT_POPUP)
const diagnosisConcern = setterReducer(false, t.SET_DIAGNOSIS_CONCERN)

const visitFeedbackOpen = (state = false, action) => {
  switch (action.type) {
    case t.SET_VISIT_FEEDBACK_OPEN:
      return action.payload
    default:
      return state
  }
}

const flaggedQuestion = (state = null, action) => {
  switch (action.type) {
    case t.SET_FLAGGED_QUESTION:
      return action.payload
    case t.SET_QUESTION_COMPLAINT:
      return { ...state, complaint: action.payload }
    default:
      return state
  }
}

const feedback = combineReducers({
  diagnosisConcern,
  explanation,
  flag,
  flagFeedback,
  flaggedQuestion,
  followUp,
  getNpsFeedback,
  npsComment,
  npsScore,
  npsSubmitted,
  showNpsCard,
  showPostIntentPopUp,
  tagging,
  unflaggedQuestion,
  visitFeedbackOpen,
})

export { feedback as default }



// WEBPACK FOOTER //
// ./assets/feedback/reducer.js